import { AI_PANEL_DEFAULT_WIDTH, AI_PANEL_MAX_WIDTH, AI_PANEL_MIN_WIDTH, AI_PANEL_WIDTH_KEY } from './aiChatConstants';

export function loadPanelWidth() {
  try {
    const saved = parseInt(localStorage.getItem(AI_PANEL_WIDTH_KEY), 10);
    if (saved >= AI_PANEL_MIN_WIDTH && saved <= AI_PANEL_MAX_WIDTH) return saved;
  } catch {
    /* ignore */
  }
  return AI_PANEL_DEFAULT_WIDTH;
}

export function clampPanelWidth(px) {
  const max = Math.min(AI_PANEL_MAX_WIDTH, Math.floor(window.innerWidth * 0.55));
  return Math.max(AI_PANEL_MIN_WIDTH, Math.min(max, px));
}
